import StoresBulkIndex from './stores_bulk_index';
import StoreBadgeEvent from './store_badge_event';

class StoreBadges {
  readonly SHOW_PARTIAL_DISPLAY = 5;
  readonly DISPLAY_LIMIT_STORE_COUNT = 1000;

  getStores(wrapper: HTMLElement, storeIds: Array<string>) {
    type brandAttributes = { id: number, name: string }
    type resultBrand = { attributes: brandAttributes }
    type storeAttributes = { id: number, name: string, chirashiru_brand_id: number, chirashiru_brand: resultBrand }
    type resultStore = { attributes: storeAttributes }
    type resultStores = { data: Array<resultStore> };

    const client = new StoresBulkIndex();
    client.getStores(storeIds).then((data) => {
      this.renderStoreBadges(wrapper, (data as resultStores).data);
    });
  }

  getBulkStores(wrapper: HTMLElement, do_type: string) {
    var allStoreIds = new Array;
    var index = 0;
    [].forEach.call(this.storeBadgesAreas(wrapper), storeBadgesArea => {
      index += 1;
      if ((storeBadgesArea as HTMLElement).dataset.status == 'loaded') {
        // ロードが完了したものはスキップする
        return;
      }
      const storeIdsStr = (storeBadgesArea as HTMLElement).dataset.storeIds;
      const storeIds = String(storeIdsStr).split(',');
      allStoreIds = allStoreIds.concat(storeIds);
      // ステータスをロード中にする
      (storeBadgesArea as HTMLElement).dataset.status = 'loading';
      if (index == this.storeBadgesAreas(wrapper).length) {
        // 全てのバッジを読み終えたら実行
        const uniqAllStoreIds = this.uniqStoreIds(allStoreIds)
        if (do_type == 'initialize' && this.DISPLAY_LIMIT_STORE_COUNT < uniqAllStoreIds.length) {
          // 所定の店舗数を超える場合は店舗を取得しない
          this.hideLoading(wrapper, 'not_load');
        } else {
          this.getStores(wrapper, uniqAllStoreIds);
        }
      }
    });
  }

  renderStoreBadges(wrapper: HTMLElement, allStores: Array<any>) {
    type brandAttributes = { id: number, name: string }
    type resultBrand = { attributes: brandAttributes }
    type storeAttributes = { id: number, name: string, chirashiru_brand_id: number, chirashiru_brand: resultBrand }
    type resultStore = { attributes: storeAttributes }

    [].forEach.call(this.storeBadgesAreas(wrapper), storeBadgesArea => {
      if ((storeBadgesArea as HTMLElement).dataset.status == 'loaded') {
        return;
      }
      const storeIdsStr = (storeBadgesArea as HTMLElement).dataset.storeIds;
      const storeIds = String(storeIdsStr).split(',');
      // 店舗を取得
      const selectedStores = allStores.filter((store) => {
        const storeAttributes = (store as resultStore).attributes;
        return (storeIds.indexOf(String(storeAttributes.id)) != -1);
      });
      // ブランドを取得
      var brands = new Array;
      [].forEach.call(selectedStores, store => {
        const storeAttributes = (store as resultStore).attributes;
        brands.push(storeAttributes.chirashiru_brand);
      });
      brands = this.uniqBrands(brands); // ブランドをユニークにする
      // ブランドから店舗を取得して表示する
      [].forEach.call(brands, brand => {
        const brandAttributes = (brand as resultBrand).attributes;
        var storesOfBrand = selectedStores.filter((store) => {
          const storeAttributes = (store as resultStore).attributes;
          return (storeAttributes.chirashiru_brand_id == brandAttributes.id);
        });
        const div = document.createElement('div');
        div.classList.add('stores-of-brand');
        // ブランド名
        const brandNameSpan = document.createElement('span');
        brandNameSpan.classList.add('brand-name');
        brandNameSpan.innerText = brandAttributes.name + ' (計' + storesOfBrand.length + ')';
        div.appendChild(brandNameSpan);
        // 店舗名
        [].forEach.call(storesOfBrand, store => {
          const storeAttributes = (store as resultStore).attributes;
          const storeNameSpan = document.createElement('span');
          storeNameSpan.classList.add('badge');
          storeNameSpan.classList.add('badge-light');
          storeNameSpan.innerText = storeAttributes.name;
          div.appendChild(storeNameSpan);
        });
        (storeBadgesArea as HTMLElement).appendChild(div);
      });
      // ステータスをロード完了にする
      (storeBadgesArea as HTMLElement).dataset.status = 'loaded';
    });
    // 読み込み中を非表示
    this.hideLoading(wrapper, 'limit');
    // 店舗バッジのイベントを入れる
    this.addEventToStoreBadge(wrapper);
  }

  uniqStoreIds(storeIds: Array<string>) {
    const knownElements: { [key: string]: Boolean } = {};
    const uniquedArray = [];
    for (let i = 0, maxi = storeIds.length; i < maxi; i++) {
      if (storeIds[i] in knownElements)
        continue;
      uniquedArray.push(storeIds[i]);
      knownElements[storeIds[i]] = true;
    }
    return uniquedArray;
  }

  uniqBrands(brands: Array<any>) {
    const knownElements: { [key: string]: Boolean } = {};
    const uniquedArray = [];
    for (let i = 0, maxi = brands.length; i < maxi; i++) {
      const brandAttributes = brands[i].attributes;
      if (brandAttributes.id in knownElements)
        continue;
      uniquedArray.push(brands[i]);
      knownElements[brandAttributes.id] = true;
    }
    return uniquedArray;
  }

  settingStoreBadges(wrapper: HTMLElement, storeBadgesArea: HTMLElement, storeIds: Array<string>, open_type: string) {
    // 初期に読み込まない場合 or 店舗数が所定の数より多い場合
    if (open_type == 'not_load' || this.SHOW_PARTIAL_DISPLAY < storeIds.length) {
      storeBadgesArea.classList.add('partial-display');
      const td = storeBadgesArea.parentElement as HTMLElement;
      if (open_type == 'not_load') {
        // 初期に読み込まない場合は読み込みを行う全てを表示するボタンを表示する
        (td.querySelector('.not-load-expand-button') as HTMLElement).classList.remove('hidden');
      } else {
        // 全ての店舗を表示するボタンを表示する
        const expandButton = td.querySelector('.expand-button') as HTMLElement
        expandButton.classList.remove('hidden');
        if (storeBadgesArea.classList.contains('not-load')) {
          // 'not-load'のクラスを削除しつつ、ボタンをクリックする (<= 店舗を読み込んだ後であるため)
          this.removeNotLoadClass(wrapper);
          expandButton.click();
        }
      }
    }
  }

  hideLoading(wrapper: HTMLElement, open_type: string) {
    [].forEach.call(this.storeBadgesAreas(wrapper), storeBadgesArea => {
      const td = (storeBadgesArea as HTMLElement).parentElement as HTMLElement;
      (td.querySelector('.store-badges-loading') as HTMLElement).style.display = 'none';
      const storeIdsStr = (storeBadgesArea as HTMLElement).dataset.storeIds;
      const storeIds = String(storeIdsStr).split(',');
      if (open_type == 'not_load') {
        // 初期で店舗を読み込まない場合は'not-load'のクラスを付与して、クリックイベントを仕込む
        (storeBadgesArea as HTMLElement).classList.add('not-load');
        (td.querySelector('.not-load-expand-button') as HTMLElement).addEventListener('click', () => {
          if ((storeBadgesArea as HTMLElement).classList.contains('not-load')) {
            this.getAndRenderStores(wrapper, storeBadgesArea);
          }
        });
      }
      this.settingStoreBadges(wrapper, storeBadgesArea, storeIds, open_type);
    });
  }

  removeNotLoadClass(wrapper: HTMLElement) {
    // 全て表示ボタンをロードを発火させるものではなく、開閉するものに表示/非表示を行う
    [].forEach.call(this.storeBadgesAreas(wrapper), storeBadgesArea => {
      (storeBadgesArea as HTMLElement).classList.remove('not-load');
      const td = (storeBadgesArea as HTMLElement).parentElement as HTMLElement;
      if (!(td.querySelector('.not-load-expand-button') as HTMLElement).classList.contains('hidden')) {
        (td.querySelector('.not-load-expand-button') as HTMLElement).classList.add('hidden');
        (td.querySelector('.expand-button') as HTMLElement).classList.remove('hidden');
      }
    });
  }

  getAndRenderStores(wrapper: HTMLElement, storeBadgesArea: HTMLElement) {
    // 全て表示ボタンを非表示にして、ローディングを表示する
    const td = storeBadgesArea.parentElement as HTMLElement;
    (td.querySelector('.store-badges-loading') as HTMLElement).style.display = 'block';
    (td.querySelector('.not-load-expand-button') as HTMLElement).classList.add('hidden');
    // 初期でロードしていない店舗を取得して、描画する
    this.getBulkStores(wrapper, 'click');
  }

  storeBadgesAreas(wrapper: HTMLElement) {
    return wrapper.querySelectorAll('.store-badges');
  }

  addEventToStoreBadge(wrapper: HTMLElement) {
    const client = new StoreBadgeEvent();
    client.initialize(wrapper);
  }

  initialize(wrapper: HTMLElement) {
    if (!this.storeBadgesAreas(wrapper).length) {
      return;
    }
    this.getBulkStores(wrapper, 'initialize');
  }
}

export default StoreBadges;
